// eslint-disable-next-line no-unused-vars
import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react'
import $ from 'jquery'; 
import Loading from './Loading';
import Select from 'react-select';
import { capitalizeFLetter, fetchItemGlobalInfo, fetchApiData } from '../../fnc'
import { utils, writeFile } from 'xlsx';
import moment from 'moment';

const refConst = require("../../constants.js").v

var initialState = {
	selected: null,
	reqDone: null, // [not execute => null, executed but not done: false, req executed and done: true]
	salesData: null,
}

var specialVar = {
	_isMounted: false
}

let stickyHeader = (item) => {
	// console.info('itemitemitemitem', item);
	
	return <span className="mr-2">{item.column.name}</span>;
}

const defaultColumnProperties = {
	resizable: true,
	headerRenderer: stickyHeader
}

export default function Export(props){

	const [selected, setSelected] = useState(initialState.selected);
	const [version, setVersion] = useState("0.1.0");
	const [salesData, setSalesData] = useState(initialState.salesData);
	const [reqDone, setReqDone] = useState(initialState.reqDone);
	const [refreshView, setRefreshView] = useState(0);

	useEffect(() => {
		specialVar._isMounted = true
		return () => specialVar._isMounted = false
	}, [])

	useEffect(() => {
		modal(true);
	}, [salesData, selected, refreshView])

	let init = () => {
		
		if(props.itemsSelected.length === 0){
			props.info({error: "Please select some items to export."})
			return;
		}

		setReqDone(false)
		resetPage()
		props.loading(true)

		console.info("Fetching sales data for selected items");
		fetchApiData("tmpWork", "get_sales_per_file_base_on_sku", {
			idProductList: props.itemsSelected.join(',')
		}, null, (r) => {
			console.info('Sales_Data_Response:', r);
			props.loading(false)
			setReqDone(true)

			if(r.success){
				setSalesData(r.data)
			} else {
				props.info({error: "Failed to fetch sales data"})
				setSalesData(null)
			}
		})

		modal(false);
	}

	let resetPage = () => {
		for (const key in initialState) {
			if (initialState.hasOwnProperty(key)) {
				const element = initialState[key];
				let val = JSON.parse(JSON.stringify(initialState[key]))
				console.info('Eval result', eval("set" + capitalizeFLetter(key))(val));
			}
		}
	}

	let modal = (refresh) => {
		props.modal({
			show: refresh? false : true,
			title: <span>Sales Report <h6 className="text-secondary d-inline ml-3 salesReportVersion">v{version}</h6></span>,
			html: (popup) => {

				return reqDone !== true? <Loading loading={true} centered={true}/> : <div className="container-fluid">
					{salesData && renderSalesView()}
				</div>
			}
			, exit: (popup, close) => {
				close()
			}
			, ok: {
				title: "Download Report",
				fnc: (popup, close) => {
					props.loading(true)
					dlFile()
					props.loading(false)
				}
			}, return: {
				title: "Close",
				fnc: (popup, close) => {
					resetPage()
					close()
				}
			}
		});
	}

	let renderSalesView = () => {
		if(!salesData) return null;

		const summary = salesData.summary || {};
		const salesByProduct = salesData.sales_by_product || [];
		const productsWithoutSales = salesData.products_without_sales || [];

		return (
			<div className="ctnSalesReport">
				{/* Summary Section */}
				<div className="card mb-3">
					<div className="card-header bg-primary text-white">
						<h5 className="mb-0">Summary</h5>
					</div>
					<div className="card-body">
						<div className="row">
							<div className="col-md-6">
								<p><strong>Date Range:</strong> {moment(summary.date_range?.from).format('MMM DD, YYYY')} to {moment(summary.date_range?.to).format('MMM DD, YYYY')}</p>
								<p><strong>Total Products Selected:</strong> {summary.input_product_ids?.length || 0}</p>
								<p><strong>Products with Sales:</strong> <span className="text-success">{summary.products_with_sales || 0}</span></p>
								<p><strong>Products without Sales:</strong> <span className="text-warning">{summary.products_without_sales || 0}</span></p>
							</div>
							<div className="col-md-6">
								<p><strong>Total Sales Records:</strong> {summary.total_sales_records || 0}</p>
								<p><strong>Total Quantity Sold:</strong> {summary.total_quantity_sold || 0}</p>
								<p><strong>Total Revenue:</strong> <span className="text-success font-weight-bold">${(summary.total_revenue || 0).toFixed(2)}</span></p>
								<p><strong>Average Revenue per Sale:</strong> ${(summary.avg_revenue_per_sale || 0).toFixed(2)}</p>
							</div>
						</div>
					</div>
				</div>

				{salesByProduct.length > 0 && (
					<div className="card mb-4 shadow-sm">
						<div className="card-header text-white salesHeaderWithSales">
							<h5 className="mb-0 salesHeaderTitle">
								<i className="fa fa-shopping-cart mr-2" aria-hidden="true"></i>
								Products with Sales <span className="badge badge-light ml-2 salesHeaderBadge">{salesByProduct.length}</span>
							</h5>
						</div>
						<div className="card-body salesTableContainer">
							<table className="table table-sm table-striped table-hover">
								<thead className="thead-dark salesTableStickyHeader">
									<tr>
										<th>SKU</th>
										<th>Brand</th>
										<th>Supplier</th>
										<th>Cost</th>
										<th>Qty Sold</th>
										<th>Orders</th>
										<th>Avg Price</th>
										<th>Revenue</th>
										<th>Profit</th>
									</tr>
								</thead>
								<tbody>
									{salesByProduct.map((product, idx) => {
										const cost = parseFloat(product.cost) || 0;
										const revenue = parseFloat(product.total_revenue) || 0;
										const quantity = parseInt(product.total_quantity_sold) || 0;
										const profit = revenue - (cost * quantity);
										const profitMargin = revenue > 0 ? ((profit / revenue) * 100).toFixed(1) : 0;
										return (
											<tr key={idx}>
												<td><small>{product.sku}</small></td>
												<td><small>{product.brand_name || '-'}</small></td>
												<td><small>{product.supplier_name || '-'}</small></td>
												<td><small>${cost.toFixed(2)}</small></td>
												<td><small>{quantity}</small></td>
												<td><small>{product.total_orders}</small></td>
												<td><small>${(parseFloat(product.avg_selling_price) || 0).toFixed(2)}</small></td>
												<td><small className="text-success font-weight-bold">${revenue.toFixed(2)}</small></td>
												<td><small className={profit >= 0 ? 'text-success' : 'text-danger'}>
													${profit.toFixed(2)} ({profitMargin}%)
												</small></td>
											</tr>
										);
									})}
								</tbody>
							</table>
						</div>
					</div>
				)}

				{/* Products without Sales */}
				{productsWithoutSales.length > 0 && (
					<div className="card mb-3">
						<div className="card-header bg-warning text-dark">
							<h5 className="mb-0">Products without Sales ({productsWithoutSales.length})</h5>
						</div>
						<div className="card-body salesTableContainerSmall">
							<table className="table table-sm table-striped">
								<thead className="thead-light salesTableStickyHeader">
									<tr>
										<th>Product ID</th>
										<th>SKU</th>
									</tr>
								</thead>
								<tbody>
									{productsWithoutSales.map((product, idx) => (
										<tr key={idx}>
											<td><small>{product.id_product}</small></td>
											<td><small>{product.sku}</small></td>
										</tr>
									))}
								</tbody>
							</table>
						</div>
					</div>
				)}
			</div>
		);
	}

	let dlFile = () => {
		if(!salesData) {
			props.info({error: "No sales data available to download"})
			return;
		}

		var book = utils.book_new();

		// Sheet 1: Summary
		const summarySheet = [
			{Field: 'Date Range From', Value: salesData.summary?.date_range?.from || ''},
			{Field: 'Date Range To', Value: salesData.summary?.date_range?.to || ''},
			{Field: 'Total Products Selected', Value: salesData.summary?.input_product_ids?.length || 0},
			{Field: 'Products with Sales', Value: salesData.summary?.products_with_sales || 0},
			{Field: 'Products without Sales', Value: salesData.summary?.products_without_sales || 0},
			{Field: 'Total Sales Records', Value: salesData.summary?.total_sales_records || 0},
			{Field: 'Total Quantity Sold', Value: salesData.summary?.total_quantity_sold || 0},
			{Field: 'Total Revenue ($)', Value: salesData.summary?.total_revenue || 0},
			{Field: 'Average Revenue per Sale ($)', Value: salesData.summary?.avg_revenue_per_sale || 0}
		];
		utils.book_append_sheet(book, utils.json_to_sheet(summarySheet), 'Summary');

		// Sheet 2: Products with Sales Summary
		if(salesData.sales_by_product && salesData.sales_by_product.length > 0) {
			const productSummary = salesData.sales_by_product.map(p => {
				const cost = parseFloat(p.cost) || 0;
				const revenue = parseFloat(p.total_revenue) || 0;
				const quantity = parseInt(p.total_quantity_sold) || 0;
				const profit = revenue - (cost * quantity);
				const profitMargin = revenue > 0 ? ((profit / revenue) * 100).toFixed(2) : 0;
				return {
					'Product ID': p.id_product,
					'SKU': p.sku,
					'Brand': p.brand_name || '',
					'Supplier': p.supplier_name || '',
					'Cost ($)': cost,
					'Total Quantity Sold': quantity,
					'Total Orders': p.total_orders,
					'Average Selling Price ($)': parseFloat(p.avg_selling_price) || 0,
					'Total Revenue ($)': revenue,
					'Profit ($)': parseFloat(profit.toFixed(2)),
					'Profit Margin (%)': parseFloat(profitMargin)
				};
			});
			utils.book_append_sheet(book, utils.json_to_sheet(productSummary), 'Products Summary');
		}

		// Sheet 3: Detailed Sales Records
		if(salesData.sales_by_product && salesData.sales_by_product.length > 0) {
			const detailedSales = [];
			salesData.sales_by_product.forEach(product => {
				if(product.sales_details && product.sales_details.length > 0) {
					const productCost = parseFloat(product.cost) || 0;
					product.sales_details.forEach(sale => {
						const sellingPrice = parseFloat(sale.selling_price) || 0;
						const quantity = parseInt(sale.quantity) || 0;
						const itemRevenue = sellingPrice * quantity;
						const itemCost = productCost * quantity;
						const itemProfit = itemRevenue - itemCost;
						
						detailedSales.push({
							'Product ID': product.id_product,
							'SKU': product.sku,
							'Brand': product.brand_name || '',
							'Supplier': product.supplier_name || '',
							'Order ID': sale.order_id,
							'Order Number': sale.order_number,
							'Order Date': sale.order_date,
							'Store': sale.store_name || '',
							'Quantity': quantity,
							'Unit Cost ($)': productCost,
							'Selling Price ($)': sellingPrice,
							'Item Revenue ($)': parseFloat(itemRevenue.toFixed(2)),
							'Item Cost ($)': parseFloat(itemCost.toFixed(2)),
							'Item Profit ($)': parseFloat(itemProfit.toFixed(2)),
							'Order Total ($)': parseFloat(sale.order_total) || 0,
							'Shipping Cost ($)': parseFloat(sale.shipping_cost) || 0,
							'Tracking Number': sale.tracking_number || ''
						});
					});
				}
			});
			if(detailedSales.length > 0) {
				utils.book_append_sheet(book, utils.json_to_sheet(detailedSales), 'Detailed Sales');
			}
		}

		// Sheet 4: Products without Sales
		if(salesData.products_without_sales && salesData.products_without_sales.length > 0) {
			const noSalesProducts = salesData.products_without_sales.map(p => ({
				'Product ID': p.id_product,
				'SKU': p.sku
			}));
			utils.book_append_sheet(book, utils.json_to_sheet(noSalesProducts), 'No Sales Products');
		}

		writeFile(book, `Sales_Report_${moment().local().format('YYYY-MM-DD_HH-mm-ss')}.xlsx`);
		props.loading(false);
	}
	
	return (<div className={"className" in props? props.className : 'list-group-item list-group-item-action p-2 text-center'} onClick={() => init(false)}>{
		props.name
	}</div>);
}